export const computedFunctions = {
  computed: {
    isCA: function() {
      return this.formdata.country.value === "CA" ? true : false;
    },
    isAU: function() {
      return this.formdata.country.value === "AU" ? true : false;
    },
    isUS: function() {
      return this.formdata.country.value === "US" ? true : false;
    },
    isNorthAmerica: function() {
      return this.$i18n.locale === "en" ? true : false;
    },
    isHE: function() {
      return this.formdata.industry.value === "Higher Education" ? true : false;
    },
    isK12: function() {
      return this.formdata.industry.value === "K-12" ? true : false;
    },
    isContent: function() {
      return this.$route.params.segment === "curriculum" ||
        this.$route.params.segment === "digital-resources" ||
        this.$route.params.segment === "adventure"
        ? true
        : false;
    },
    isCorpPage: function() {
      return this.$route.params.segment === "corp" ? true : false;
    },
    isCorporateTrial: function() {
      return this.isCorp || this.isAssoc || this.isTraining;
    },
    isAssoc: function() {
      return this.formdata.industry.value === "Associations" ||
        this.formdata.industry.value === "Non-Profit"
        ? true
        : false;
    },
    isTraining: function() {
      return this.formdata.industry.value === "Professional Training" ||
        this.formdata.industry.value === "Education Services" ||
        this.formdata.industry.value === 'Training Organization' ||
        this.formdata.industry.value === 'Safety Training'
        ? true
        : false;
    },
    isGovernment: function () {
      return this.formdata.industry.value === 'Government' ? true : false;
    },
    isNotForProfit: function () {
      return this.formdata.industry.value === 'Not for Profit' ? true : false;
    },
    isCorp: function() {
      return this.formdata.industry.value === "Corporate" || this.formdata.industry.value === "Other" ? true : false;
    },
    isMasterclass: function() {
      return this.sandbox &&
        this.sandbox.login_url === "https://opencourses.desire2learn.com"
        ? true
        : false;
    },
    isPartner: function() {
      return this.formdata.interest.value === "partner" ? true : false;
    },
    isCustomer: function () {
      return this.formdata.customer.value === "true" ? true : false;
    },
    isFireFox: function() {
      return this.$browserDetect.isFirefox;
    },
    win10: function() {
      return JSON.stringify(this.$browserDetect).match(
        /.*Windows(\sNT)?\s10.*/g
      )
        ? true
        : false;
    },
    showState: function() {
      return this.isCA || this.isAU || this.isUS;
    },
    loadingPercent: function() {
      return Math.round((this.loadingProgress / this.loadingTime) * 100);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/exports/computedFunctions.js